import Api from '@/services/Api';
import Axios from 'axios';

export default {
	async login(email, password) {
		const data = {
			grant_type: 'password',
			username: email,
			password: password,
			client_id: process.env.VUE_APP_CLIENT_ID,
			client_secret: process.env.VUE_APP_CLIENT_SECRET
		};

		return await Api.post('/oauth/token', data);
	},

	async user() {
		return await Api.get('/api/user');
	},

	async refreshToken() {
		const data = {
			grant_type: 'refresh_token',
			refresh_token: localStorage.refreshToken,
			client_id: process.env.VUE_APP_CLIENT_ID,
			client_secret: process.env.VUE_APP_CLIENT_SECRET
		};

		// Using fresh Axios instance to avoid sending expired accessToken
		const instance = Axios.create({
			baseURL: process.env.VUE_APP_BACKEND_URL
		});

		return await instance.post('/oauth/token', data);
	},

	async resetPasswordRequest(email) {
		return await Api.get('/api/request-reset-password', {
			params: { email }
		});
	},

	async testResetPasswordToken(token, email) {
		return await Api.get(`/api/reset-password/${token}`, {
			params: { email }
		});
	},

	async resetPassword(token, email, password) {
		return await Api.post('/api/reset-password', { email, token, password });
	}
};
